import React from 'react';
import LandingPage from './pages/LandingPage';
import MobileNotice from './components/MobileNotice';

const App = () => {
  return (
      <>
      <LandingPage />
      {/* <MobileNotice /> */}
      </>
  )
};  

export default App;
